import Swiper, { Navigation, Pagination } from 'swiper';

export default class VideoSlider {
    constructor(query) {
        const el = document.querySelector(query);
        if (!el) return;

        this.el = el;
        this.init();
    }

    init() {
        const slider = document.querySelector('#video-slider');
        if (!slider) return;

        const btnNext = this.el.querySelector('.video-slider__btn-next');
        const btnPrev = this.el.querySelector('.video-slider__btn-prev');
        const slides = [...slider.querySelectorAll('.video-slider__item')];
        let playBtn = slider.querySelector('.video-slider__play-btn');

        let isDesktop = window.innerWidth > 1024;
        let desktopSwiper = null;
        let mobileSwiper = null;

        const deactivateAllVideos = (activeIndex) => {
            slides.forEach((slide, index) => {
                if (index === activeIndex) return;
                const videoDesktop = slide.querySelector('.video-slider__item-video:not(.mobile) video');
                const previewDesktop = slide.querySelector('.video-slider__item-video:not(.mobile) .video-slider__item-preview');
                const videoMobile = slide.querySelector('.video-slider__item-video.mobile video');
                const previewMobile = slide.querySelector('.video-slider__item-video.mobile .video-slider__item-preview');
                const volumeControler = slide.querySelector('.video-slider__volume');
                const volumeText = volumeControler && volumeControler.querySelector('.video-slider__volume-text');

                [previewDesktop, previewMobile].forEach(preview => {
                    if (preview) preview.classList.remove('hidden');
                });

                [videoDesktop, videoMobile].forEach(video => {
                    if (video) {
                        video.pause();
                        video.currentTime = 0;
                        video.classList.add('hidden');
                    }
                });

                if (volumeControler) {
                    volumeControler.classList.remove('active', 'volume-on');
                    volumeControler.classList.add('volume-off');
                    if (volumeText) volumeText.textContent = 'OFF';
                }
            });
        };

        const resetSlideStyles = () => {
            slides.forEach(slide => {
                slide.style.transform = '';
                slide.style.maxWidth = '';
                slide.style.zIndex = '';
            });
        };

        const setupSlideInteraction = (slidesArr, desktopMode) => {
            slidesArr.forEach(slide => {
                const video = desktopMode
                    ? slide.querySelector('.video-slider__item-video:not(.mobile) video')
                    : slide.querySelector('.video-slider__item-video.mobile video');
                const preview = desktopMode
                    ? slide.querySelector('.video-slider__item-video:not(.mobile) .video-slider__item-preview')
                    : slide.querySelector('.video-slider__item-video.mobile .video-slider__item-preview');
                const volumeControler = slide.querySelector('.video-slider__volume');
                const volumeText = volumeControler && volumeControler.querySelector('.video-slider__volume-text');
                let isVolumeOn = video && !video.muted;
                let hoverTimeout;
                const isLast = slide.classList.contains('last-slide');

                const updateVolumeUI = () => {
                    if (!volumeControler) return;
                    if (isVolumeOn) {
                        volumeControler.classList.add('volume-on');
                        volumeControler.classList.remove('volume-off');
                        if (volumeText) volumeText.textContent = 'ON';
                    } else {
                        volumeControler.classList.add('volume-off');
                        volumeControler.classList.remove('volume-on');
                        if (volumeText) volumeText.textContent = 'OFF';
                    }
                };

                const toggleVolume = (state) => {
                    if (!video) return;
                    if (state !== undefined) isVolumeOn = state;
                    else isVolumeOn = !isVolumeOn;
                    video.muted = !isVolumeOn;
                    updateVolumeUI();
                };

                updateVolumeUI();

                if (volumeControler) {
                    volumeControler.onclick = (e) => {
                        e.stopPropagation();
                        toggleVolume();
                    };
                }

                if (desktopMode) {
                    const maxWidth = 710;
                    const baseWidth = slide.offsetWidth;
                    const expandWidth = maxWidth - baseWidth;

                    slide.onmouseenter = () =>  {
                        hoverTimeout = setTimeout(() => {
                            slidesArr.forEach(videoSlide => {
                                if (videoSlide === slide) return;
                                const slidePreview = videoSlide.querySelector('.video-slider__item-video:not(.mobile) .video-slider__item-preview');
                                const vol = videoSlide.querySelector('.video-slider__volume');
                                const volText = videoSlide.querySelector('.video-slider__volume-text');
                                videoSlide.querySelectorAll('video').forEach(slideVideo => {
                                    if (slideVideo) {
                                        slideVideo.pause();
                                        slideVideo.currentTime = 0;
                                        slideVideo.muted = true;
                                        slideVideo.classList.add('hidden');
                                    }
                                });
                                if (slidePreview) slidePreview.classList.remove('hidden');
                                if (vol) {
                                    vol.classList.remove('volume-on', 'active');
                                    vol.classList.add('volume-off');
                                }
                                if (volText) volText.textContent = 'OFF';
                            });

                            if (preview) preview.classList.add('hidden');
                            if (video) {
                                video.classList.remove('hidden');
                                video.muted = !isVolumeOn;
                                video.volume = 0.5;
                                video.play().catch(() => {});
                            }
                            if (volumeControler) volumeControler.classList.add('active');
                            updateVolumeUI();
                        }, 200);

                        slide.style.zIndex = 5;

                        if (isLast) {
                            slide.style.transform = `translateX(-${expandWidth}px)`;
                            const index = slidesArr.indexOf(slide);
                            for (let i = 0; i < index; i++) {
                                slidesArr[i].style.transform = `translateX(-${expandWidth}px)`;
                            }
                        } else {
                            slide.style.transformOrigin = 'left center';
                        }

                        slide.style.maxWidth = `${maxWidth}px`;
                    }

                    slide.onmouseleave = () => {
                        slide.style.maxWidth = '';
                        slide.style.transform = '';
                        slide.style.zIndex = '';
                        clearTimeout(hoverTimeout);

                        if (video) {
                            video.pause();
                            video.currentTime = 0;
                            video.classList.add('hidden');
                        }
                        if (preview) preview.classList.remove('hidden');
                        toggleVolume(false);
                        if (volumeControler) volumeControler.classList.remove('active');

                        if (isLast) {
                            const index = slidesArr.indexOf(slide);
                            for (let i = 0; i < index; i++) {
                                slidesArr[i].style.transform = '';
                            }
                        }
                    };

                    slide.onclick = null;
                } else {
                    slide.onclick = null;
                }
            });
        };

        const updateButtons = () => {
            if (!btnPrev || !btnNext) return;

            if ((desktopSwiper && desktopSwiper.isBeginning) || (mobileSwiper && mobileSwiper.isBeginning)) {
                btnPrev.classList.add('disabled');
            } else {
                btnPrev.classList.remove('disabled');
            }

            if ((desktopSwiper && desktopSwiper.isEnd) || (mobileSwiper && mobileSwiper.isEnd)) {
                btnNext.classList.add('disabled');
            } else {
                btnNext.classList.remove('disabled');
            }
        };

        const desktopSlider = () => {
            if (!isDesktop) return;

            if (desktopSwiper) desktopSwiper.destroy(true, true);

            desktopSwiper = new Swiper(slider, {
                modules: [Navigation],
                slidesPerView: 'auto',
                spaceBetween: 20,
                navigation: {
                    nextEl: btnNext,
                    prevEl: btnPrev,
                },
                on: {
                    init() {
                        updateButtons();
                        this.slides.forEach((slide, index) => {
                            slide.classList.toggle('active', index === this.realIndex);
                        });
                    },
                    slideChange () {
                        updateButtons();
                        this.slides.forEach((slide, index) => {
                            slide.classList.toggle('active', index === this.realIndex);
                        });
                    },
                    resize() {
                        updateButtons();
                    }
                }
            });

            setupSlideInteraction(desktopSwiper.slides, true);
        };

        const mobileSlider = () => {
            if (mobileSwiper) mobileSwiper.destroy(true, true);

            mobileSwiper = new Swiper(slider, {
                modules: [Navigation, Pagination],
                slidesPerView: 'auto',
                spaceBetween: 20,
                pagination: {
                    el: '.video-slider__pagination',
                    clickable: true,
                    bulletClass: 'video-slider__pagination-bullet',
                    bulletActiveClass: 'video-slider__pagination-bullet-active',
                },
                navigation: {
                    nextEl: btnNext,
                    prevEl: btnPrev,
                },
                on: {
                    slideChange: () => {
                        deactivateAllVideos(mobileSwiper.realIndex);
                        if (playBtn) playBtn.classList.remove('pause');

                        const activeSlide = mobileSwiper.slides[mobileSwiper.realIndex];
                        const video = activeSlide.querySelector('.video-slider__item-video.mobile video');
                        const preview = activeSlide.querySelector('.video-slider__item-video.mobile .video-slider__item-preview');
                        const volumeControler = activeSlide.querySelector('.video-slider__volume');
                        const volumeText = volumeControler && volumeControler.querySelector('.video-slider__volume-text');
                        if (video) {
                            setTimeout(() => {
                                video.classList.remove('hidden');
                                video.volume = 0.5;
                                video.muted = true;
                                video.play().catch(() => {});
                                if (preview) preview.classList.add('hidden');
                                if (volumeControler) {
                                    volumeControler.classList.add('active');
                                    if (volumeText) volumeText.textContent = 'OFF';
                                }
                                playBtn.classList.add('pause');

                                const endedHandler = () => {
                                    video.pause();
                                    video.currentTime = 0;
                                    video.classList.add('hidden');
                                    if (preview) preview.classList.remove('hidden');
                                    if (volumeControler) volumeControler.classList.remove('active');
                                    playBtn.classList.remove('pause');
                                    video.removeEventListener('ended', endedHandler);
                                };
                                video.addEventListener('ended', endedHandler);
                            }, 500);
                        }
                    }
                }
            });

            setupSlideInteraction(mobileSwiper.slides, false);

            if (!playBtn) return;
            const newPlayBtn = playBtn.cloneNode(true);
            playBtn.parentNode.replaceChild(newPlayBtn, playBtn);
            playBtn = newPlayBtn;

            const togglePlay = (auto = false) => {
                if (!mobileSwiper) return;
                const activeSlide = mobileSwiper.slides[mobileSwiper.realIndex];
                const video = activeSlide.querySelector('.video-slider__item-video.mobile video');
                const preview = activeSlide.querySelector('.video-slider__item-video.mobile .video-slider__item-preview');
                const volumeControler = activeSlide.querySelector('.video-slider__volume');
                const volumeText = volumeControler && volumeControler.querySelector('.video-slider__volume-text');
                let isVolumeOn = video && !video.muted;

                const updateVolumeUI = () => {
                    if (!volumeControler) return;
                    if (isVolumeOn) {
                        volumeControler.classList.add('volume-on');
                        volumeControler.classList.remove('volume-off');
                        if (volumeText) volumeText.textContent = 'ON';
                    } else {
                        volumeControler.classList.add('volume-off');
                        volumeControler.classList.remove('volume-on');
                        if (volumeText) volumeText.textContent = 'OFF';
                    }
                };

                const toggleVolume = (state) => {
                    if (!video) return;
                    if (state !== undefined) isVolumeOn = state;
                    else isVolumeOn = !isVolumeOn;
                    video.muted = !isVolumeOn;
                    updateVolumeUI();
                };

                if (!video) return;

                const isPlaying = !video.classList.contains('hidden');

                if (!isPlaying) {
                    deactivateAllVideos(mobileSwiper.realIndex);
                    if (preview) preview.classList.add('hidden');
                    video.classList.remove('hidden');
                    video.volume = 0.5;
                    video.muted = !isVolumeOn;
                    video.loop = false;
                    video.play().catch(() => {});
                    if (volumeControler) volumeControler.classList.add('active');
                    updateVolumeUI();
                    playBtn.classList.add('pause');

                    if (auto) {
                        const endedHandler = () => {
                            video.pause();
                            video.currentTime = 0;
                            video.classList.add('hidden');
                            if (preview) preview.classList.remove('hidden');
                            if (volumeControler) volumeControler.classList.remove('active');
                            playBtn.classList.remove('pause');
                            video.removeEventListener('ended', endedHandler);
                        };
                        video.addEventListener('ended', endedHandler);
                    } else {
                        video.onended = null;
                    }
                } else if (!auto) {
                    video.pause();
                    video.currentTime = 0;
                    video.classList.add('hidden');
                    if (preview) preview.classList.remove('hidden');
                    if (volumeControler) volumeControler.classList.remove('active');
                    toggleVolume(false);
                    playBtn.classList.remove('pause');
                }
            }

            playBtn.addEventListener('click', () => togglePlay(false));

            let autoPlayed = false;
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        if (!autoPlayed) {
                            autoPlayed = true;
                            setTimeout(() => togglePlay(true), 500);
                        }
                    } else {
                        autoPlayed = false;
                        slides.forEach(slide => {
                            const video = slide.querySelector('.video-slider__item-video.mobile video');
                            const preview = slide.querySelector('.video-slider__item-video.mobile .video-slider__item-preview');
                            const volumeControler = slide.querySelector('.video-slider__volume');

                            if (video) {
                                video.pause();
                                video.currentTime = 0;
                                video.classList.add('hidden');
                            }
                            if (preview) preview.classList.remove('hidden');
                            if (volumeControler) volumeControler.classList.remove('active');
                        });
                        if (playBtn) playBtn.classList.remove('pause');
                    }
                });
            }, { threshold: 0.5 });

            observer.observe(slider);

        };

        const removeDesktopHover = (slidesArr) => {
            slidesArr.forEach(slide => {
                slide.onmouseenter = null;
                slide.onmouseleave = null;
                slide.onclick = null;
            });
        };

        const handleResize = () => {
            const nowDesktop = window.innerWidth > 1024;
            if (nowDesktop !== isDesktop) {
                isDesktop = nowDesktop;

                resetSlideStyles();
                const activeIndex = mobileSwiper ? mobileSwiper.realIndex : null;
                deactivateAllVideos(activeIndex);
                if (playBtn) playBtn.classList.remove('pause');

                if (desktopSwiper) {
                    removeDesktopHover(desktopSwiper.slides);
                    desktopSwiper.destroy(true, true);
                    desktopSwiper = null;
                }
                if (mobileSwiper) {
                    mobileSwiper.destroy(true, true);
                    mobileSwiper = null;
                }

                if (isDesktop) desktopSlider();
                else mobileSlider();
            }
            
            if (desktopSwiper) desktopSwiper.update();
            if (mobileSwiper) mobileSwiper.update();
        };

        if (isDesktop) desktopSlider();
        else mobileSlider();

        window.addEventListener('resize', () => {
            handleResize();
            updateButtons();
        });
    }
}